var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-date-picker", {
    staticClass: "custom-date-picker",
    attrs: {
      type: "daterange",
      align: "right",
      "value-format": "yyyy-MM-dd",
      "unlink-panels": "",
      "range-separator": " ",
      offset: [-10, 10],
      "start-placeholder": _vm.$t("language.emailTransfer.startDate"),
      "end-placeholder": _vm.$t("language.emailTransfer.endDate"),
      "append-to-body": false,
      clearable: false
    },
    scopedSlots: _vm._u([
      {
        key: "range-separator",
        fn: function() {
          return [
            _c("i", {
              staticClass: "icon-util arrow-purple arrow-purple-position"
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.date,
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03f31c38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f31c38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/selector/date_selector.vue
// module id = null
// module chunks = 